<script setup lang="ts">
import SidebarSection from '@/components/Sidebar/SidebarSection.vue'
import TtAccordion from '@/components/TtAccordion.vue'
import { useMetaFilterStore } from '@/store/metafilter'
import { storeToRefs } from 'pinia'

const filterStore = useMetaFilterStore()
const { filter } = storeToRefs(filterStore)
</script>

<template>
  <div class="px-0 pb-20 sm:pb-0">
    <SidebarSection
      v-if="filter"
      v-for="(section, i) in filter.get()"
      :key="section.label"
      :hasBorder="true"
    >
      <TtAccordion
        :closed="true"
        :allways-show-icons="true"
      >
        <template v-slot:accordionButton>
          <h2 class="text-lg font-semibold leading-9 tracking-tight">
            {{ section.label }}
          </h2>
        </template>
        <div>
        </div>
      </TtAccordion>
    </SidebarSection>
  </div>
</template>
